import { render, staticRenderFns } from "./MainTab.vue?vue&type=template&id=a1b29af2"
import script from "./MainTab.vue?vue&type=script&lang=js"
export * from "./MainTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports